import React, { useEffect, useState } from "react";
import { BindPostAPI, IUDAPI } from "../services/APIConnection";
import MainLayout from "../components/MainLayout";
import Checkbox from "../ReusableComponents/Checkbox";
import Loader from "../ReusableComponents/Loader";
import toast from "react-hot-toast";

const AnswerSubmission = () => {
  const [checkboxStatus, setCheckboxStatus] = useState();
  const [buttonDisable, setButtonDisable] = useState(true);
  const [buttonEnable, setButtonEnable] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [answerStatus, setAnswerStatus] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const partnerId = sessionStorage.getItem("partnerId");
  const fetchData = async () => {
    ;
    const data = { MstPartnerId: partnerId };
    // const response = await BindPostAPI(
    //   data,
    //   "AnswerQuestionsAPI/BindAnswerQuestions"
    // );
    // const answers = response?.data?.Table3;
    const answerResponse = await BindPostAPI(
      data,
      "AnswerQuestionsAPI/BindAnswerSubmission"
    );
    const answersResponse = answerResponse?.data?.Table;
    debugger;
    setAnswerStatus(answersResponse?.[0]?.AnswerStatus);
    
   // setButtonEnable(answers?.[0]?.CompletionStatus);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleChange = (updatedOptions) => {
    setCheckboxStatus(updatedOptions);

    if (updatedOptions.length > 0) {
      setButtonDisable(false);
    } else {
      setButtonDisable(true);
    }
  };
  const handleSubmit = async () => {
    setButtonDisable(true);
    setIsLoading(true);
    const payload = {
      MstPartnerId: partnerId,
    };
    const response = await IUDAPI(
      payload,
      "AnswerQuestionsAPI/AnswerCompletionMail"
    );
    if (response.data.Table) {
      toast.success("Answer Submitted Successfully. 👍", {
        duration: 3000,
        position: "top-center",
      });
       fetchData();
      setIsLoading(false);
    }
  };
  return (
    <MainLayout pageName="4">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      <div class="my-1 max-lg:mt-4 mx-2 lg:mx-4 text-xl font-medium text-neutral-700">
            Assessment Submission
          </div>
      {/* {answerStatus != null && !answerStatus && ( */}
        {/* {answerStatus == 3 && (
        <div className="border p-4 lg:mx-4  rounded-md shadow-sm">
          <div className="mb-2 text-xs text-red-500 italic flex justify-center">
            You have not answered any questions. Please answer the questions before submitting.
          </div>
        </div>
      )}  */}
      {/* {buttonEnable != null && buttonEnable && ( */}
      {answerStatus == 2 && (
        <div className="border p-4 lg:mx-4 rounded-md shadow-sm">
          <div className="mb-2 text-xs text-red-500 italic flex justify-center">
            You have already submited the answer for assessment.
          </div>
        </div>
      )} 
      {/* { !buttonEnable && answerStatus && ( */}
      {(answerStatus == 1 || answerStatus == 3) && (
        
          
          <div className="border rounded-md lg:mx-4 shadow-sm">
            <div class="my-1 py-2 max-lg:mt-4 mx-2 lg:mx-4 text-sm max-h-52 overflow-auto font-medium text-neutral-700">
              You are submitting the answers to ethosflo analyst for assessment.
              Note that you will not able to make any changes. Once you submit
              click on below confirm button once you are ready.
            </div>
            <div className="">
              <div className=" text-xs p-2 lg:px-4 text-red-500 flex flex-col">
                <Checkbox
                  Class="flex"
                  title="Terms and Conditions :"
                  options={[
                    {
                      value: 1,
                      label: "I accept the terms and conditions.",
                    },
                  ]}
                  controlFunc={handleChange} // or a real function handler
                  disabled={false}
                  setName={"checkboxStatus"}
                  selectedOptions={checkboxStatus ? checkboxStatus : []}
                  tabIndex="0"
                />
                <div className="flex mb-2 justify-center">
                  <button
                    disabled={buttonDisable}
                    onClick={() => handleSubmit()}
                    className={`px-4 py-1 rounded text-white 
            ${
              buttonDisable
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gray-600 hover:bg-gray-700"
            }`}
                  >
                    Completed Answers
                  </button>
                  {/* <button
                onClick={() => handleSubmit()}
                className={`px-4 py-1 rounded text-white bg-gray-600 hover:bg-gray-700    `}
              >
                Completed Answers
              </button> */}
                </div>
              </div>
            </div>
          </div>
        
      )}
    </MainLayout>
  );
};

export default AnswerSubmission;
